/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CallerRef,
  InitiateOAuthResult,
  MapMailboxIdOutreachObjectMailboxIdMailboxOutreachRelations,
  MapOutreachProspectIdOutreachObjectOutreachProspectIdProspectOutreachRelations,
  MapOutreachUserIdOutreachObjectOutreachUserIdUserOutreachRelations,
  MapSequenceIdOutreachObjectSequenceIdSequenceOutreachRelations,
  MapSequenceStepIdOutreachObjectSequenceStepIdSequenceStepOutreachRelations,
  MapString,
  OutreachObjectMailboxIdMailboxOutreachRelations,
  OutreachObjectOutreachProspectIdProspectOutreachRelations,
  OutreachObjectOutreachUserIdUserOutreachRelations,
  OutreachObjectSequenceIdSequenceOutreachRelations,
  OutreachObjectSequenceStepIdSequenceStepOutreachRelations,
  PaginatedResultOutreachObjectMailboxIdMailboxOutreachRelations,
  PaginatedResultOutreachObjectOutreachProspectIdProspectOutreachRelations,
  PaginatedResultOutreachObjectOutreachUserIdUserOutreachRelations,
  PaginatedResultOutreachObjectSequenceIdSequenceOutreachRelations,
  PaginatedResultOutreachObjectSequenceStepIdSequenceStepOutreachRelations,
  WrappedCredentialView,
} from "./data-contracts";
import { FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "outreach";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * No description
   *
   * @tags OAuth
   * @name OutreachOAuthCallback
   * @request GET:/v1/public/oauth/callback
   */
  outreachOAuthCallback = (
    query: {
      state: string;
      /** @pattern [^\s\\/]+ */
      code?: string;
      /** @pattern [^\s\\/]+ */
      error?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      any,
      | void
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/oauth/callback`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Returns string containing request path for outreachOAuthCallback */
  outreachOAuthCallbackPathGetter = (query: {
    state: string;
    /** @pattern [^\s\\/]+ */
    code?: string;
    /** @pattern [^\s\\/]+ */
    error?: string;
  }) => this.getServicePath(`/v1/public/oauth/callback`, query);

  /**
   * No description
   *
   * @tags OAuth
   * @name InitiateOAuthFlow
   * @request GET:/v1/tenant/{tenantId}/oauth/initiate
   * @secure
   */
  initiateOAuthFlow = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      InitiateOAuthResult,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/oauth/initiate`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for initiateOAuthFlow */
  initiateOAuthFlowPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/oauth/initiate`);

  /**
   * No description
   *
   * @tags Sequence, Queries
   * @name ListSequences
   * @request GET:/v1/tenant/{tenantId}/sequences-list
   * @secure
   */
  listSequences = (
    tenantId: string,
    query?: {
      /**
       *
       * filters results to only include object related to specified objects
       * format: $relation:$id1,$id2,....$idn
       *
       * available relations: user, updater, sequence, mailings, sequenceSteps, sequenceStates, mailboxes
       * @default []
       * @example ["sequence:1,2"]
       */
      inRelationTo?: string[];
      /**
       * filter=$field:$value
       * @default []
       * @example ["shareType:shared","locked:false","enabled:true"]
       */
      filter?: string[];
      /**
       * csv of $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updatedAt:DESC,createdAt:ASC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultOutreachObjectSequenceIdSequenceOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/sequences-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listSequences */
  listSequencesPathGetter = (
    tenantId: string,
    query?: {
      /**
       *
       * filters results to only include object related to specified objects
       * format: $relation:$id1,$id2,....$idn
       *
       * available relations: user, updater, sequence, mailings, sequenceSteps, sequenceStates, mailboxes
       * @default []
       * @example ["sequence:1,2"]
       */
      inRelationTo?: string[];
      /**
       * filter=$field:$value
       * @default []
       * @example ["shareType:shared","locked:false","enabled:true"]
       */
      filter?: string[];
      /**
       * csv of $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updatedAt:DESC,createdAt:ASC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/sequences-list`, query);

  /**
   * No description
   *
   * @tags Sequence, Queries
   * @name SequenceById
   * @request GET:/v1/tenant/{tenantId}/sequences/{sequenceId}
   * @secure
   */
  sequenceById = (tenantId: string, sequenceId: number, params: RequestParams = {}) =>
    this.request<
      OutreachObjectSequenceIdSequenceOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/sequences/${sequenceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for sequenceById */
  sequenceByIdPathGetter = (tenantId: string, sequenceId: number) =>
    this.getServicePath(`/v1/tenant/${tenantId}/sequences/${sequenceId}`);

  /**
   * No description
   *
   * @tags Sequence, Queries
   * @name SequencesByIds
   * @request GET:/v1/tenant/{tenantId}/sequences
   * @secure
   */
  sequencesByIds = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapSequenceIdOutreachObjectSequenceIdSequenceOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/sequences`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for sequencesByIds */
  sequencesByIdsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/sequences`, query);

  /**
   * No description
   *
   * @tags Mailbox, Queries
   * @name ListMailboxes
   * @request GET:/v1/tenant/{tenantId}/mailboxes-list
   * @secure
   */
  listMailboxes = (
    tenantId: string,
    query?: {
      /**
       *
       * filters results to only include object related to specified objects
       * format: $relation:$id1,$id2,....$idn
       *
       * available relations: user, updater, sequence, mailings, sequenceSteps, sequenceStates, mailboxes
       * @default []
       * @example ["sequence:1,2"]
       */
      inRelationTo?: string[];
      /**
       * filter=$field:$value
       * @default []
       * @example ["shareType:shared","locked:false","enabled:true"]
       */
      filter?: string[];
      /**
       * csv of $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updatedAt:DESC,createdAt:ASC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultOutreachObjectMailboxIdMailboxOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/mailboxes-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listMailboxes */
  listMailboxesPathGetter = (
    tenantId: string,
    query?: {
      /**
       *
       * filters results to only include object related to specified objects
       * format: $relation:$id1,$id2,....$idn
       *
       * available relations: user, updater, sequence, mailings, sequenceSteps, sequenceStates, mailboxes
       * @default []
       * @example ["sequence:1,2"]
       */
      inRelationTo?: string[];
      /**
       * filter=$field:$value
       * @default []
       * @example ["shareType:shared","locked:false","enabled:true"]
       */
      filter?: string[];
      /**
       * csv of $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updatedAt:DESC,createdAt:ASC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/mailboxes-list`, query);

  /**
   * No description
   *
   * @tags Mailbox, Queries
   * @name MailboxById
   * @request GET:/v1/tenant/{tenantId}/mailboxes/{mailboxId}
   * @secure
   */
  mailboxById = (tenantId: string, mailboxId: number, params: RequestParams = {}) =>
    this.request<
      OutreachObjectMailboxIdMailboxOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/mailboxes/${mailboxId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for mailboxById */
  mailboxByIdPathGetter = (tenantId: string, mailboxId: number) =>
    this.getServicePath(`/v1/tenant/${tenantId}/mailboxes/${mailboxId}`);

  /**
   * No description
   *
   * @tags Mailbox, Queries
   * @name MailboxesByIds
   * @request GET:/v1/tenant/{tenantId}/mailboxes
   * @secure
   */
  mailboxesByIds = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapMailboxIdOutreachObjectMailboxIdMailboxOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/mailboxes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for mailboxesByIds */
  mailboxesByIdsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/mailboxes`, query);

  /**
   * No description
   *
   * @tags Sequence Step, Queries
   * @name ListSequenceSteps
   * @request GET:/v1/tenant/{tenantId}/sequence-steps-list
   * @secure
   */
  listSequenceSteps = (
    tenantId: string,
    query?: {
      /**
       *
       * filters results to only include object related to specified objects
       * format: $relation:$id1,$id2,....$idn
       *
       * available relations: user, updater, sequence, mailings, sequenceSteps, sequenceStates, mailboxes
       * @default []
       * @example ["sequence:1,2"]
       */
      inRelationTo?: string[];
      /**
       * filter=$field:$value
       * @default []
       * @example ["shareType:shared","locked:false","enabled:true"]
       */
      filter?: string[];
      /**
       * csv of $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updatedAt:DESC,createdAt:ASC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultOutreachObjectSequenceStepIdSequenceStepOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/sequence-steps-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listSequenceSteps */
  listSequenceStepsPathGetter = (
    tenantId: string,
    query?: {
      /**
       *
       * filters results to only include object related to specified objects
       * format: $relation:$id1,$id2,....$idn
       *
       * available relations: user, updater, sequence, mailings, sequenceSteps, sequenceStates, mailboxes
       * @default []
       * @example ["sequence:1,2"]
       */
      inRelationTo?: string[];
      /**
       * filter=$field:$value
       * @default []
       * @example ["shareType:shared","locked:false","enabled:true"]
       */
      filter?: string[];
      /**
       * csv of $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updatedAt:DESC,createdAt:ASC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/sequence-steps-list`, query);

  /**
   * No description
   *
   * @tags Sequence Step, Queries
   * @name SequenceStepById
   * @request GET:/v1/tenant/{tenantId}/sequence-steps/{sequenceStepId}
   * @secure
   */
  sequenceStepById = (tenantId: string, sequenceStepId: number, params: RequestParams = {}) =>
    this.request<
      OutreachObjectSequenceStepIdSequenceStepOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/sequence-steps/${sequenceStepId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for sequenceStepById */
  sequenceStepByIdPathGetter = (tenantId: string, sequenceStepId: number) =>
    this.getServicePath(`/v1/tenant/${tenantId}/sequence-steps/${sequenceStepId}`);

  /**
   * No description
   *
   * @tags Sequence Step, Queries
   * @name SequenceStepsByIds
   * @request GET:/v1/tenant/{tenantId}/sequence-steps
   * @secure
   */
  sequenceStepsByIds = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapSequenceStepIdOutreachObjectSequenceStepIdSequenceStepOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/sequence-steps`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for sequenceStepsByIds */
  sequenceStepsByIdsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/sequence-steps`, query);

  /**
   * No description
   *
   * @tags User, Queries
   * @name ListUsers
   * @request GET:/v1/tenant/{tenantId}/users-list
   * @secure
   */
  listUsers = (
    tenantId: string,
    query?: {
      /**
       *
       * filters results to only include object related to specified objects
       * format: $relation:$id1,$id2,....$idn
       *
       * available relations: user, updater, sequence, mailings, sequenceSteps, sequenceStates, mailboxes
       * @default []
       * @example ["sequence:1,2"]
       */
      inRelationTo?: string[];
      /**
       * filter=$field:$value
       * @default []
       * @example ["shareType:shared","locked:false","enabled:true"]
       */
      filter?: string[];
      /**
       * csv of $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updatedAt:DESC,createdAt:ASC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultOutreachObjectOutreachUserIdUserOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listUsers */
  listUsersPathGetter = (
    tenantId: string,
    query?: {
      /**
       *
       * filters results to only include object related to specified objects
       * format: $relation:$id1,$id2,....$idn
       *
       * available relations: user, updater, sequence, mailings, sequenceSteps, sequenceStates, mailboxes
       * @default []
       * @example ["sequence:1,2"]
       */
      inRelationTo?: string[];
      /**
       * filter=$field:$value
       * @default []
       * @example ["shareType:shared","locked:false","enabled:true"]
       */
      filter?: string[];
      /**
       * csv of $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updatedAt:DESC,createdAt:ASC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users-list`, query);

  /**
   * No description
   *
   * @tags User, Queries
   * @name UserById
   * @request GET:/v1/tenant/{tenantId}/users/{outreachUserId}
   * @secure
   */
  userById = (tenantId: string, outreachUserId: number, params: RequestParams = {}) =>
    this.request<
      OutreachObjectOutreachUserIdUserOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users/${outreachUserId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for userById */
  userByIdPathGetter = (tenantId: string, outreachUserId: number) =>
    this.getServicePath(`/v1/tenant/${tenantId}/users/${outreachUserId}`);

  /**
   * No description
   *
   * @tags User, Queries
   * @name UsersByIds
   * @request GET:/v1/tenant/{tenantId}/users
   * @secure
   */
  usersByIds = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapOutreachUserIdOutreachObjectOutreachUserIdUserOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for usersByIds */
  usersByIdsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/users`, query);

  /**
   * No description
   *
   * @tags Prospect, Queries
   * @name ListProspects
   * @request GET:/v1/tenant/{tenantId}/prospect-list
   * @secure
   */
  listProspects = (
    tenantId: string,
    query?: {
      /**
       *
       * filters results to only include object related to specified objects
       * format: $relation:$id1,$id2,....$idn
       *
       * available relations: user, updater, sequence, mailings, sequenceSteps, sequenceStates, mailboxes
       * @default []
       * @example ["sequence:1,2"]
       */
      inRelationTo?: string[];
      /**
       * filter=$field:$value
       * @default []
       * @example ["shareType:shared","locked:false","enabled:true"]
       */
      filter?: string[];
      /**
       * csv of $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updatedAt:DESC,createdAt:ASC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultOutreachObjectOutreachProspectIdProspectOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/prospect-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listProspects */
  listProspectsPathGetter = (
    tenantId: string,
    query?: {
      /**
       *
       * filters results to only include object related to specified objects
       * format: $relation:$id1,$id2,....$idn
       *
       * available relations: user, updater, sequence, mailings, sequenceSteps, sequenceStates, mailboxes
       * @default []
       * @example ["sequence:1,2"]
       */
      inRelationTo?: string[];
      /**
       * filter=$field:$value
       * @default []
       * @example ["shareType:shared","locked:false","enabled:true"]
       */
      filter?: string[];
      /**
       * csv of $field(:$order)? <br> available orders: ASC,DESC
       * @minLength 1
       * @example "updatedAt:DESC,createdAt:ASC"
       */
      orderBy?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/prospect-list`, query);

  /**
   * No description
   *
   * @tags Prospect, Queries
   * @name ProspectById
   * @request GET:/v1/tenant/{tenantId}/prospect/{prospectId}
   * @secure
   */
  prospectById = (tenantId: string, prospectId: number, params: RequestParams = {}) =>
    this.request<
      OutreachObjectOutreachProspectIdProspectOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/prospect/${prospectId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for prospectById */
  prospectByIdPathGetter = (tenantId: string, prospectId: number) =>
    this.getServicePath(`/v1/tenant/${tenantId}/prospect/${prospectId}`);

  /**
   * No description
   *
   * @tags Prospect, Queries
   * @name ProspectsByIds
   * @request GET:/v1/tenant/{tenantId}/prospect
   * @secure
   */
  prospectsByIds = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapOutreachProspectIdOutreachObjectOutreachProspectIdProspectOutreachRelations,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/prospect`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for prospectsByIds */
  prospectsByIdsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example [1,2]
       */
      ids: number[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/prospect`, query);

  /**
   * No description
   *
   * @tags Credentials
   * @name GetOutreachCredentialsView
   * @request GET:/v1/tenant/{tenantId}/credential/organization
   * @secure
   */
  getOutreachCredentialsView = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      WrappedCredentialView,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/credential/organization`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getOutreachCredentialsView */
  getOutreachCredentialsViewPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/credential/organization`);

  /**
   * No description
   *
   * @tags Credentials
   * @name DeleteOutreachCredential
   * @request DELETE:/v1/tenant/{tenantId}/credential/organization
   * @secure
   */
  deleteOutreachCredential = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/credential/organization`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteOutreachCredential */
  deleteOutreachCredentialPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/credential/organization`);
}
